var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEgypt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 39.9999C31.0454 39.9999 39.9998 31.0456 39.9998 19.9999C39.9998 8.95418 31.0454 -0.00012207 19.9998 -0.00012207C8.95406 -0.00012207 -0.000244141 8.95418 -0.000244141 19.9999C-0.000244141 31.0456 8.95406 39.9999 19.9998 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 0C11.4006 0 4.06976 5.4275 1.2439 13.0435H38.756C35.9301 5.4275 28.5992 0 19.9999 0V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 39.9999C28.5992 39.9999 35.9301 34.5724 38.7559 26.9564H1.2439C4.06976 34.5724 11.4006 39.9999 19.9999 39.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9563 17.8259H21.7389C21.7389 16.8655 20.9602 16.0868 19.9998 16.0868C19.0393 16.0868 18.2606 16.8655 18.2606 17.8259H13.0432C13.0432 18.7865 13.8799 19.5651 14.8403 19.5651H14.7824C14.7824 20.5256 15.5609 21.3042 16.5215 21.3042C16.5215 22.2648 17.3001 23.0434 18.2606 23.0434H21.7389C22.6995 23.0434 23.4781 22.2648 23.4781 21.3042C24.4386 21.3042 25.2172 20.5256 25.2172 19.5651H25.1593C26.1198 19.5651 26.9563 18.7865 26.9563 17.8259V17.8259Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgypt);
export default __webpack_public_path__ + "static/media/egypt.2233e66eedda356d1854b42c1da2b060.svg";
export { ForwardRef as ReactComponent };